import { useQuery, UseQueryResult } from 'react-query';
import type { WorkoutAthleteCalendar } from 'types/generated/models/WorkoutAthleteCalendar';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface UseAthleteWorkoutsCalendarParams {
  athlete?: string;
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
}

function useAthleteWorkoutsCalendar({
  athlete,
  startDate,
  endDate,
  enabled = true,
}: UseAthleteWorkoutsCalendarParams = {}): UseQueryResult<{ data: WorkoutAthleteCalendar[] }> {
  return useQuery(
    ['workouts', 'athleteCalendar', athlete, startDate, endDate],
    () =>
      client.get(
        `workouts/athlete-calendar/?${encodeUrlParams({
          athlete: athlete as string,
          start_date: startDate as string,
          end_date: endDate as string,
        })}`,
      ),
    {
      enabled: enabled && !!athlete && !!startDate && !!endDate && endDate >= startDate,
    },
  );
}

export default useAthleteWorkoutsCalendar;
